import React, { useEffect, useState } from "react";
import ApiService from "../../services/api-service";
import Loader from "../../components/Loader";
import notifier from "../../components/Notifier";
import { useHistory } from "react-router-dom";
import { fullName } from "../../constants/function";
import "../../pages/Home/Home.scss";

const FeaturedArtists = () => {
  const [featuredArtists, setFeaturedArtists] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const fetchFeaturedArtists = async () => {
    try {
      setLoading(true);
      const response = await ApiService.FEATURE_ARTIST("");
      setFeaturedArtists(response?.result || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching featured artists:", error);
      setLoading(false);
      notifier.error("Failed to fetch featured artists. Please try again later.");
    }
  };

  useEffect(() => {
    fetchFeaturedArtists();
  }, []);

  const handleArtistClick = (artistId) => {
    history.push(`/app/ArtistProfile/${artistId}`);
  };

  if (loading) {
    return <Loader message="Loading Featured Artists..." />;
  }

  if (featuredArtists.length === 0) {
    return null;
  }

  return (
    <section className="siki-artists-section siki-fade-up">
      <div className="siki-section-label">Creators</div>
      <div className="siki-section-header">
        <h2 className="siki-section-title">Top Artists</h2>
        <div className="siki-section-action" onClick={() => history.push("/app/feature/artists")}>
          Explore →
        </div>
      </div>

      <div className="siki-artists-scroll">
        {featuredArtists.map((artist) => (
          <div
            key={artist._id}
            className="siki-artist-card"
            onClick={() => handleArtistClick(artist._id)}
          >
            <div className="siki-artist-avatar-ring">
              <div className="siki-artist-avatar">
                <img
                  src={artist.profileImg?.filePath || "/default-avatar.jpg"}
                  alt={fullName(artist)}
                  onError={(e) => {
                    e.target.src = "https://via.placeholder.com/120?text=No+Avatar";
                  }}
                />
              </div>
              {/* Add live badge if artist is live - you can add logic here */}
              {/* {artist.isLive && (
                <div className="siki-artist-live-badge">Live</div>
              )} */}
            </div>
            {/* Printing firstName raw left a blank row for artists whose name
                fields are empty, and the word "null" for those whose name was
                stored as a placeholder. */}
            <div className="siki-artist-name">{fullName(artist)}</div>
            {artist.genre && (
              <div className="siki-artist-genre">{artist.genre}</div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturedArtists;
